import { Avatar, MediaObject, Paragraph } from '@zillow/constellation-10';
import type { SelectedGuarantorCompanyWebApiDto } from '@zg-rentals/ts-capps-client';

export function GuarantorCompanySummary({ guarantorCompany }: { guarantorCompany: SelectedGuarantorCompanyWebApiDto }) {
  return (
    <MediaObject
      media={<Avatar fullName={guarantorCompany.displayName} tone="accent-1" size="sm" />}
      css={{ alignItems: 'center' }}
    >
      <Paragraph textStyle="body-sm-bold">{guarantorCompany.displayName}</Paragraph>
      <Paragraph textStyle="body-xs" css={{ color: 'text.subtle' }}>
        Your landlord will contact you if anything else is needed.
      </Paragraph>
    </MediaObject>
  );
}
